import { render, staticRenderFns } from "./ExampleContentDownloadButton.vue?vue&type=template&id=6baca803&scoped=true"
import script from "./ExampleContentDownloadButton.vue?vue&type=script&lang=js"
export * from "./ExampleContentDownloadButton.vue?vue&type=script&lang=js"
import style0 from "./ExampleContentDownloadButton.vue?vue&type=style&index=0&id=6baca803&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6baca803",
  null
  
)

export default component.exports